export const getColumnWidths = (columns) =>
  columns
    .map((column) => ({
      columnName: column.name ?? column.columnName,
      ...(column.width !== undefined && { width: column.width }),
      ...(column.minWidth !== undefined && { minWidth: column.minWidth }),
      ...(column.grow !== undefined && { grow: column.grow }),
      ...(column.sizing !== undefined && { sizing: column.sizing }),
      ...(column.align !== undefined && { align: column.align }),
      ...(column.wordWrapEnabled !== undefined && {
        wordWrapEnabled: column.wordWrapEnabled
      })
    }))
    .filter((column) => column.columnName);
